module.exports = __webpack_public_path__ + "img/mobile/Background/background@2x.jpg?0.0.53";